module.exports = __webpack_public_path__ + "static/media/bannerImage2-m.fabe4fbf.jpg";